import { isMiniApp, isWeChatMiniProgram, isWeb, isByteDanceMicroApp, isKuaiShouMiniProgram, isBaiduSmartProgram } from "@uni/env";
import * as aliMiniAppModule from "./ali-miniapp/index";
import * as weChatModule from "./wechat-miniprogram/index";
import * as bytedanceModule from "./bytedance-microapp/index";
import * as webModule from "./web/index";
import * as kuaiShouModule from "./kuaishou-miniprogram/index";
import * as baiDuModule from "./baidu-smartprogram/index";
export var upload = function upload(options) {
  if (isWeb) {
    return webModule.upload(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.upload(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.upload(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.upload(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.upload(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.upload(options);
  } else {
    throw new Error('@uni：upload暂不支持');
  }
};
export var download = function download(options) {
  if (isWeb) {
    return webModule.download(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.download(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.download(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.download(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.download(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.download(options);
  } else {
    throw new Error('@uni：download暂不支持');
  }
};
export var getInfo = function getInfo(options) {
  if (isWeb) {
    return webModule.getInfo(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getInfo(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.getInfo(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getInfo(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.getInfo(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getInfo(options);
  } else {
    throw new Error('@uni：getInfo暂不支持');
  }
};
export var getSavedInfo = function getSavedInfo(options) {
  if (isWeb) {
    return webModule.getSavedInfo(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getSavedInfo(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.getSavedInfo(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getSavedInfo(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.getSavedInfo(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getSavedInfo(options);
  } else {
    throw new Error('@uni：getSavedInfo暂不支持');
  }
};
export var getSavedList = function getSavedList(options) {
  if (isWeb) {
    return webModule.getSavedList(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getSavedList(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.getSavedList(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getSavedList(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.getSavedList(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getSavedList(options);
  } else {
    throw new Error('@uni：getSavedList暂不支持');
  }
};
export var save = function save(options) {
  if (isWeb) {
    return webModule.save(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.save(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.save(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.save(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.save(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.save(options);
  } else {
    throw new Error('@uni：save暂不支持');
  }
};
export var removeSaved = function removeSaved(options) {
  if (isWeb) {
    return webModule.removeSaved(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.removeSaved(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.removeSaved(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.removeSaved(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.removeSaved(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.removeSaved(options);
  } else {
    throw new Error('@uni：removeSaved暂不支持');
  }
};
export var openDocument = function openDocument(options) {
  if (isWeb) {
    return webModule.openDocument(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.openDocument(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.openDocument(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.openDocument(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.openDocument(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.openDocument(options);
  } else {
    throw new Error('@uni：openDocument暂不支持');
  }
};
export default {
  openDocument: openDocument,
  removeSaved: removeSaved,
  upload: upload,
  save: save,
  getSavedList: getSavedList,
  getSavedInfo: getSavedInfo,
  getInfo: getInfo,
  download: download
};